import { ChainId, Token } from 'pancakeswap-sdk'

export const CAKE: { [chainId: number]: Token } = {
  [ChainId.TESTNET]: new Token(
    ChainId.TESTNET,
    '0xdcddF4dc462F036445BA3fF19F7df91436bA4669',
    18,
    'WOLF',
    'WolfSwap Token',
  ),
}

export const WTLOS = new Token(
  ChainId.TESTNET,
  '0xaE85Bf723A9e74d6c663dd226996AC1b8d075AA9',
  18,
  'WTLOS',
  'Wrapped TLOS',
)
export const LOL = new Token(ChainId.TESTNET, '0xdc96321d95BBC44721e49248989179a95A738B27', 4, 'LOL', 'LOL')
export const FIAT = new Token(ChainId.TESTNET, '0xD159C4E586421a507907faD705e067bfB350dc07', 4, 'FIAT', 'FIAT')
export const SOON = new Token(ChainId.TESTNET, '0xE9c31091868d68598Ac881738D159A63532d12f9', 9, 'SOON', 'SOON')

const tmpProjectLink = 'http://ec2-18-219-143-73.us-east-2.compute.amazonaws.com'

const tokens = {
  tlos: {
    symbol: 'TLOS',
    projectLink: tmpProjectLink,
  },
  cake: {
    symbol: 'WOLF',
    address: {
      41: '0xdcddF4dc462F036445BA3fF19F7df91436bA4669',
    },
    decimals: 18,
    projectLink: tmpProjectLink,
  },
  wtlos: {
    symbol: 'wTLOS',
    address: {
      41: '0xaE85Bf723A9e74d6c663dd226996AC1b8d075AA9',
    },
    decimals: 18,
    projectLink: tmpProjectLink,
  },
  syrup: {
    symbol: 'SYRUP',
    address: {
      41: '0x6D88C058A3f50D97fabd17FD201e1A0EA54A0c9e',
    },
    decimals: 18,
    projectLink: tmpProjectLink,
  },
  lol: {
    symbol: 'LOL',
    address: {
      41: '0xdc96321d95BBC44721e49248989179a95A738B27',
    },
    decimals: 4,
    projectLink: tmpProjectLink,
  },
  fiat: {
    symbol: 'FIAT',
    address: {
      41: '0xD159C4E586421a507907faD705e067bfB350dc07',
    },
    decimals: 4,
    projectLink: tmpProjectLink,
  },
  soon: {
    symbol: 'SOON',
    address: {
      41: '0xE9c31091868d68598Ac881738D159A63532d12f9',
    },
    decimals: 9,
    projectLink: tmpProjectLink,
  },
}

export default tokens
